export default {
  'sendticket.sendticket': 'INVIA BIGLIETTO',
  'sendticket.sentsuccessfully': 'Biglietto Inviato con Successo',
  'sendticket.replytickets': 'Rispondi ai Biglietti',
  'sendticket.you': 'Tu',
  'sendticket.operator': 'Operatore',
  'sendticket.reply': 'RISPONDI',
  'sendticket.createdat': 'Creato In',
  'sendticket.laststatus': 'Ultimo Stato',
  'sendticket.ticketid': 'ID Biglietto',
  'sendticket.closeticketquestion':
    'Il tuo biglietto è riuscito correttamente?',
  'sendticket.closeticket': 'Sì, Chiudi questo biglietto',
  'sendticket.notcloseticket': 'No',
  'sendticket.closedsuccessfully': 'Biglietto chiuso con successo',
  'sendticket.downloadfile': 'Scarica File',
  'sendticket.daysago': 'giorni fa',
  'sendticket.hoursago': 'ore fa',
  'sendticket.minutesago': 'minuti fa',
  'sendticket.yes': 'sì, è stato risposto',
  'sendticket.today': '( In data odierna )',
  'sendticket.yesterday': '( ieri )',
  'sendticket.justnow': 'proprio adesso',
};
